import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Loader2, ChevronLeft, ChevronRight, ShieldCheck, Mail, Phone, MapPin } from "lucide-react";

const CAT_ORDER = ["Customer", "Professional", "Data & Platform", "Operational"];

export default function Legal() {
    const [policies, setPolicies] = useState(null);
    const [cfg, setCfg] = useState(null);
    const nav = useNavigate();

    useEffect(() => {
        api.get("/legal/policies").then((r) => setPolicies(r.data)).catch(() => setPolicies([]));
        api.get("/legal/config").then((r) => setCfg(r.data)).catch(() => {});
    }, []);

    const grouped = {};
    (policies || []).forEach((p) => { (grouped[p.category] = grouped[p.category] || []).push(p); });
    const cats = Object.keys(grouped).sort((a, b) => CAT_ORDER.indexOf(a) - CAT_ORDER.indexOf(b));

    return (
        <div className="mx-auto min-h-screen max-w-md bg-lightbg">
            <div className="rounded-b-3xl bg-navy px-5 pb-7 pt-5 text-white">
                <button data-testid="legal-back-btn" onClick={() => nav(-1)} className="mb-4 flex items-center gap-1 text-sm text-white/70"><ChevronLeft size={18} /> Back</button>
                <Logo size={36} light />
                <h1 className="mt-4 font-heading text-2xl font-extrabold">Legal & Policies</h1>
                {cfg && (
                    <div className="mt-2 space-y-0.5 text-xs text-white/60">
                        <p className="flex items-center gap-1.5"><ShieldCheck size={13} /> Operated by {cfg.operator}</p>
                        <p className="flex items-center gap-1.5"><MapPin size={13} /> {cfg.city} · {cfg.service_areas?.join(", ")}</p>
                        <p>Policy version {cfg.current_version}</p>
                    </div>
                )}
            </div>

            <div className="px-5 py-5">
                {policies === null && <div className="flex justify-center py-12"><Loader2 className="h-7 w-7 animate-spin text-orange" /></div>}
                {policies && cats.map((cat) => (
                    <section key={cat} className="mb-6">
                        <h2 className="mb-2 text-xs font-bold uppercase tracking-wider text-navy/40">{cat}</h2>
                        <div className="overflow-hidden rounded-2xl border border-navy/10 bg-white">
                            {grouped[cat].map((p) => (
                                <Link
                                    key={p.slug}
                                    to={`/legal/${p.slug}`}
                                    data-testid={`legal-link-${p.slug}`}
                                    className="flex items-center gap-3 border-b border-navy/5 px-4 py-3.5 last:border-0 transition-colors hover:bg-navy/[0.02]"
                                >
                                    <span className="font-heading text-sm font-bold text-orange">{String(p.number).padStart(2, "0")}</span>
                                    <span className="flex-1 text-sm font-semibold text-navy">{p.title}</span>
                                    <ChevronRight size={17} className="text-navy/25" />
                                </Link>
                            ))}
                        </div>
                    </section>
                ))}

                {cfg && (
                    <div className="rounded-2xl border border-navy/10 bg-white p-4 text-xs text-navy/60">
                        <p className="mb-2 font-bold text-navy">Grievance & Support</p>
                        <p className="flex items-center gap-1.5"><Mail size={13} /> {cfg.support_email}</p>
                        <p className="mt-1 flex items-center gap-1.5"><Phone size={13} /> {cfg.support_phone}</p>
                    </div>
                )}
            </div>
        </div>
    );
}
